import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import { approvalTypeInitialState, ApprovalTypeStateProps, approvalTypeStateStore } from './approval-type-state.store';
import { select } from '@ngneat/elf';

@Injectable({
  providedIn: 'root',
})
export class ApprovalTypeRepository extends BaseStoreRepository<ApprovalTypeStateProps> {
  constructor() {
    super(approvalTypeStateStore.pipe(select(state => state)), approvalTypeStateStore, approvalTypeInitialState);
  }
}
